const AnalyticalGovernanceHandoff = ({ handoffStatus = "ready", onRetryPersistence, onContinue, handoffError }) => (
  <section
    aria-labelledby="analytical-governance-handoff-title"
    className="border-y border-slate-200 py-4"
  >
    <p className="text-xs font-semibold uppercase tracking-[0.18em] text-slate-500">
      From analysis to governance
    </p>
    <div className="mt-2 flex flex-col gap-3 sm:flex-row sm:items-end sm:justify-between">
      <div>
        <h2
          id="analytical-governance-handoff-title"
          className="text-base font-semibold text-slate-950"
        >
          Management Recommendation <span>→</span>{" "}
          Investment Governance
        </h2>
        <p className="mt-1 max-w-3xl text-sm leading-6 text-slate-600">
          {handoffStatus === "ready"
            ? "Management-constrained modeled allocation is ready for project substantiation in Investment Planning. Board review and authorization remain downstream."
            : "Complete a comparable Management-constrained evaluation for the current requested capital and persist the Management request before continuing."}
        </p>
      </div>
      {handoffStatus === "ready" ? <button type="button" onClick={onContinue}
        className="shrink-0 inline-flex rounded-lg bg-cyan-700 px-4 py-2 text-sm font-semibold text-white hover:bg-cyan-800 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-cyan-700"
        disabled={!onContinue}
      >
        Continue to Investment Planning
      </button> : (
        <div role={handoffStatus === "failed" ? "alert" : "status"} className="max-w-sm text-sm font-medium text-amber-800">
          {handoffStatus === "failed" ? (
            <><span>{handoffError || "The Management request was not persisted. Retry persistence before continuing to Investment Planning."}</span>{onRetryPersistence && <button type="button" onClick={onRetryPersistence} className="ml-2 font-semibold text-blue-700 underline">Retry persistence</button>}</>
          ) : handoffStatus === "persisting"
            ? "Persisting the Management request before Investment Planning…"
            : handoffStatus === "stale"
              ? "Management Requested Capital changed. Re-evaluate the current amount before continuing to Investment Planning."
              : "Investment Planning is unavailable until current READY and Comparable evidence is persisted."}
        </div>
      )}
    </div>
  </section>
);

export default AnalyticalGovernanceHandoff;
